import debounce from "lodash/debounce";

const state = {
    searchQuery: "",
    searchType: null,
    results: {},
    isLoading: false,
};

const actions = {
    updateSearchQuery(context, query) {
        context.state.searchQuery = query;

        if (context.state.searchQuery.length >= 3) {
            context.commit('startLoading');
            context.dispatch('requestSearch');
        }
    },

    updateSearchType(context, searchType) {
        context.state.searchType = searchType === 'null' ? null : searchType;

        if (context.state.searchQuery.length >= 3) {
            context.commit('startLoading');
            context.dispatch('requestSearch');
        }
    },

    requestSearch: debounce(function ({dispatch}) {
        dispatch("handleSearch");
    }, 500),

    handleSearch(context) {
        let params = {};

        if (context.state.searchQuery !== null && context.state.searchQuery !== "") {
            params.search = context.state.searchQuery;
        }
        if (context.state.searchType !== null) {
            params['type'] = context.state.searchType;
        }

        if(!_.isEmpty(params)) {
            axios.post(`/api/site/search/`, params)
            .then(response => {
                if (response.data) {
                    context.state.results = response.data;
                }

                context.commit('doneLoading');
            });
        }
    },
};

const mutations = {
    startLoading(state) {
        state.isLoading = true;
    },
    doneLoading(state) {
        state.isLoading = false;
    }
};
const getters = {
    searchPageUrl: state => {
        let url = `/search/${state.searchQuery}/`;

        if (state.searchType) {
            url += `?type=${state.searchType}`;
        }

        return url;
    },
};

export const search = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
